/* Low Budget TCG — theme JS. Scoped, no Dawn interference. */
(function () {
  function init() {
    // Reveal on scroll for elements with .lbtcg-reveal inside .lbtcg sections
    var revealEls = document.querySelectorAll('.lbtcg .lbtcg-reveal');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    // Touch-drag scrolling for horizontal trending feed on desktop (left mouse)
    document.querySelectorAll('.lbtcg-feed-row--scroll').forEach(function (row) {
      var isDown = false, startX = 0, scrollLeft = 0;
      row.addEventListener('mousedown', function (e) {
        isDown = true; startX = e.pageX - row.offsetLeft; scrollLeft = row.scrollLeft;
        row.style.cursor = 'grabbing';
      });
      ['mouseleave', 'mouseup'].forEach(function (ev) {
        row.addEventListener(ev, function () { isDown = false; row.style.cursor = ''; });
      });
      row.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        row.scrollLeft = scrollLeft - (e.pageX - row.offsetLeft - startX) * 1.4;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
